import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './OfferPopup.css';

// Hero-sized offer banner. Image-only: the whole banner is one link.
// Banner click also dismisses (marks session dismissed) so the popup never
// re-appears after navigating to the target page.
// Hidden until designer files exist — no fallback, no broken image.
export default function OfferPopup({
  open,
  onClose,
  desktopSrc,
  mobileSrc,
  alt = 'Special offer from Scallop',
  ctaLink = '/accounts',
}) {
  const [imgOk, setImgOk] = useState(true);

  useEffect(() => {
    if (!open) return;
    setImgOk(true);
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open || !imgOk) return null;
  if (!desktopSrc && !mobileSrc) return null;

  const isExternal = ctaLink.startsWith('http');

  const banner = (
    <picture>
      {desktopSrc && <source media="(min-width: 810px)" srcSet={desktopSrc} />}
      <img
        src={mobileSrc || desktopSrc}
        alt={alt}
        loading="eager"
        onError={() => setImgOk(false)}
      />
    </picture>
  );

  return (
    <div className="offer-popup-overlay" onClick={onClose} role="presentation">
      <div
        className="offer-popup-wrap"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={alt}
      >
        {isExternal ? (
          <a
            href={ctaLink}
            className="offer-popup-card"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={alt}
            onClick={onClose}
          >
            {banner}
          </a>
        ) : (
          <Link
            to={ctaLink}
            className="offer-popup-card"
            aria-label={alt}
            onClick={onClose}
          >
            {banner}
          </Link>
        )}
        <button
          type="button"
          className="offer-popup-close"
          onClick={onClose}
          aria-label="Close offer"
        >
          ×
        </button>
      </div>
    </div>
  );
}
